/**
 * Container for the Badges component
 */
import React from 'react'
import { connect } from 'react-redux'
import { RootStoreState } from '../../root/index'
import { Manifest } from 'mytours-read-api-typescript'

export interface Props {
	appManifest?: Manifest
}

const mapStateToProps = (state: RootStoreState): Props => ({
	appManifest: state.settings.appManifest,
})

export default (Component: React.ComponentType<Props>) => connect(mapStateToProps)(Component)
